module.exports = __webpack_public_path__ + "static/media/wizualizacja-46.d63ad541.png";